import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { type ShipmentCategoryEntity } from '@/libs/api'

import { getShipmentCategoriesSelectQueryOptions } from '../query-options'

/**
 * Select用の配送種別一覧のUseQuery
 */
export const useShipmentCategoriesSelectQuery = (
  tenantKey: string,
  options?: {
    disabled?: boolean
    dcId?: number
    shippingDate?: string
  }
): UseQueryResult<ShipmentCategoryEntity[]> => {
  const disabled = options?.disabled ?? false
  const dcId = options?.dcId
  const shippingDate = options?.shippingDate
  return useQuery<ShipmentCategoryEntity[]>({
    ...getShipmentCategoriesSelectQueryOptions(tenantKey, dcId, shippingDate),
    enabled: !disabled,
    retry: false
  })
}
